/***************************************************************************************************
** useIsValueChanged
***************************************************************************************************/

import { useState, useEffect } from "react";

const defaultOptions = {
  blankValues: [undefined, null, ""],
  valueFn: (v) => v,
};

export default function useIsValueChanged(
  initialValue = undefined,
  currentValue = undefined,
  options = {}
) {
  const {
    blankValues,
    valueFn,
  } = { ...defaultOptions, ...options };

  const [isValueChanged, setIsValueChanged] = useState(false);

  useEffect(() => {
    let isChanged = false;

    if (!(blankValues.includes(initialValue) && blankValues.includes(currentValue))) {
      isChanged = valueFn(initialValue) !== valueFn(currentValue);
    }

    setIsValueChanged(isChanged);

    if (options.setIsValueChanged) {
      options.setIsValueChanged(isChanged);
    }
  }, [initialValue, currentValue, blankValues, valueFn, options]);

  return isValueChanged;
}
